import React from "react";

function AffiliateProgram() {
    return <div className="tab AffiliateProgram">
        <h2>Affiliate-Programm</h2>
    </div>;
}

export default AffiliateProgram;